import { useQuery } from '@tanstack/react-query';
import { fetchPayments, type FetchPaymentsParams } from '@/lib/api';

interface UsePaymentsOptions extends FetchPaymentsParams {
  refetchInterval?: number;
}

export function usePayments(options: UsePaymentsOptions) {
  const { refetchInterval = 15_000, ...params } = options;

  return useQuery({
    queryKey: ['payments', params],
    queryFn: () => fetchPayments(params),
    refetchInterval,
  });
}
